// extracted by mini-css-extract-plugin
export default {"iconWithLabel":"activity_iconWithLabel__he0Qn"};